export const zh = {
  title: '',
  subtitle: '2000/2010, Hansen/UMD/Google/USGS/NASA',
  download_data: 'https://glad.umd.edu/dataset/global-2010-tree-cover-30-m',
  learn_more: 'http://science.sciencemag.org/content/342/6160/850',
  content: [
    {
      label: '功能',
      value: '标识森林覆盖区域',
    },
    {
      label: '分辨率',
      value: '0 × 30 米',
    },
    {
      label: '地理覆盖范围',
      value: '全球土地（不包括南极洲和北极群岛）',
    },
    {
      label: '来源',
      value:
        'Hansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available from: https://glad.umd.edu/dataset/global-2010-tree-cover-30-m.',
    },
    {
      label: '更新频率',
      value: '',
    },
    {
      label: '内容日期',
      value: '2000 & 2010',
    },
    {
      label: '注意事项',
      value:
        '为了这次研究的需要，“森林覆盖”定义为高于 5 米的植被。“森林覆盖”是树木的生物物理展现并且可能在一定范围的森林覆盖密度内以自然森林或者人工林的形式存在。',
    },
    {
      label: '许可证',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: '概览',
    value:
      '该数据集由马里兰大学的GLAD（全球土地分析& 发现）实验室、Google、USGS和NASA合作完成，以30×30米的分辨率显示了2000年和2010年全球所有陆地（除南极和一些北极岛屿）的树木覆盖情况。“树木覆盖率”的定义是树冠覆盖地表的密度，并按密度等级进行颜色编码（见图例）。\n\n本层的数据是使用 Landsat 7 专题制图仪 plus (ETM+) 传感器的多光谱卫星图像生成的。来自 600,000 多张图像的清晰表面观测结果通过 Google Earth Engine（一个用于地球观测和数据分析的云平台）进行了分析，以便使用监督型学习算法确定每个像素的树木覆盖率。\n\n所显示数据的林木冠层覆盖密度由于选择的不同而变化，使用地图上的图例来改变林木冠层覆盖密度最低阈值。',
  },
  citation: {
    label: '引用',
    value:
      'Use the following credit when these data are displayed:\nSource: Hansen/UMD/Google/USGS/NASA, accessed through Global Forest Watch\n\nUse the following credit when these data are cited:\nHansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available on-line from:https://glad.umd.edu/dataset/global-2010-tree-cover-30-m. Accessed through Global Forest Watch on 11/02/2025. www.globalforestwatch.org',
  },
};
